<style>


.thumbnails-container {
  /*background-color: #fff;*/
  width: 300px;
  //padding-top: 50px;
  margin-top: 1px;
  position: relative;
  display: none;
}

.thumbnails-container.collapsed {
  width: 70px;
  .thumbnail {
    width: 39px;
  }
  .thumbnails-header div {
    display: none;
  }
  .section-disable-switch {
    display: none;
  }
  .thumbnail-title__name {
    display: none;
  }
}

.thumbnails-header {
  display: flex;
  align-items: center;
  padding: 20px 0;
  gap: 10px;
  justify-content: space-between;
}
/*
.thumbnails {
  width: 77px;
}
*/
.thumbnails {
  position: fixed;
  overflow-y: auto;
  height: calc(100vh - 100px); /* less distance from the top of the screen */
  /*display: flex;*/
  flex-direction: column;
  width: 310px;
  padding: 0 10px 20px 20px;

  .v-card {
    width: 100%;
    margin-bottom: 4px;
    overflow: hidden;
    /*border: 1px solid #ddd;*/
    padding: 7px 0 7px 10px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
}

.thumbnail {
  transition: margin-left 50ms;
  border: 1px solid transparent;

  .thumbnail-title {
    display: flex;
    /*font-family: 'Carlito';*/
    font-size: 13px;
    line-height: 1.2;
    color: #000;
    justify-content: space-between;
    align-items: center;
    width: 100%;

  &.thumbnail-disabled {
    color: #787878;
    .v-icon {
      color: #787878;
    }
  }

  &.thumbnail-disabling {
    /* animation */
    animation: pulse-black 10s normal;
  }

  .v-icon {
    color: #000;
  }
  }

  &.active {
   cursor: default;
   background-color: #fff;
   border: 1px solid #c1d4e8;
  }

  &.active .thumbnail-title {
    font-weight: bold;
  }
}

</style>


<template>
  <div
    v-if="$store.state.isEditingToolsVisible && (!$store.state.activeTemplate.showOnboardingDialog
    || $store.state.activeTemplate.isGenerating === 'progress'
    || $store.state.activeTemplate.isGenerating === 'done')"
    class="thumbnails-container"
    :class="thumbnailsCollapsed && 'collapsed'"
  >
    <div class="thumbnails">
      <div class="thumbnails-header">
        <div style="font-size: 14px; text-transform: uppercase;"
        >
          <span>{{ translate('ui_sheets') }}</span>
        </div>
        <v-btn
            @click="thumbnailsCollapsed = !thumbnailsCollapsed"
            color="#828282"
            outlined
            elevation="0"
            style="padding: 4px; min-width: 0; height: auto;"
        >
          <v-icon v-if="!thumbnailsCollapsed" style="font-size: 16px;">mdi-arrow-collapse-left</v-icon>
          <v-icon v-if="thumbnailsCollapsed" style="font-size: 16px;">mdi-arrow-collapse-right</v-icon>
        </v-btn>
      </div>

      <div
        v-for="(module) in modules"
        :key="module.id"
        class="thumbnail v-card"
        :class="$store.state.activeTemplate.data.activeSectionId === module.id && 'active'"
        @click="activateSection(module.id)"
        style="overflow: visible;"
      >
        <div
          :class="{ 'thumbnail-disabled': !module.isEnabled, 'thumbnail-disabling': module.isDisabling}"
          class="thumbnail-title"
      >
          <div style="display: flex; width: 100%;">
            <div style="display:flex; gap: 10px; align-items: center;">
              <div style="position: relative;">
                <span
                  v-if="module.isNew"
                  style="z-index: 1; transform: rotate(-24deg); position:absolute; top: -3px; left: -16px; font-size: 10px; background-color: forestgreen; color: #fff; padding: 2px 3px; border-radius: 3px;">new
                </span>
                <v-icon
                  v-if="module.isInitialized === true"
                  :size="16"
                  :width="2"
                >
                  {{ module.icon ? module.icon : 'mdi-table' }}
                </v-icon>
                <v-icon
                  v-if="module.isInitialized === 'queued'"
                  color="#8c8c8c"
                  :size="16"
                  :width="2"
                >mdi-timer-sand</v-icon>
                <v-progress-circular
                  v-if="module.isInitialized === 'progress'"
                  color="#8c8c8c"
                  :size="16"
                  :width="1"
                  indeterminate
                ></v-progress-circular>
                <v-progress-linear
                    v-if="module.isEnabled && module.isUpdating"
                    color="deep-purple accent-4"
                    indeterminate
                    rounded
                    height="3"
                    style="position:absolute;"
                ></v-progress-linear>
              </div>

              <div class="thumbnail-title__name">
                <div
                  style="padding-top: 1px;"
                  :style="!module.isInitialized || module.isInitialized === 'queued' ? 'color: #8c8c8c;' : ''"
                >{{ translate(module.nameLong || module.id) }}</div>
                <!--
                <div v-if="module.nameLong" style="font-size: 10px; color: #555; margin-top: 2px;">
                  {{ translate(module.nameLong) }}
                </div>
                -->
              </div>
            </div>
            <v-spacer/>
            <TemplateSectionDisableSwitch
              v-if="shouldShowSectionDisableSwitch(module)"
              :module="module"
              :horizontal="true"
              :hideLabel="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Mixin from '@/mixins/mixin';
import TemplateSectionDisableSwitch from '@/components/sections/TemplateSection/TemplateSectionDisableSwitch';

export default {
  name: 'TemplatePreviewThumbnails',
  components: { TemplateSectionDisableSwitch },
  mixins: [Mixin],
  data: () => ({
    thumbnailsCollapsed: false,
  }),
  computed: {
    modules() {
      return this.$store.state.activeTemplate.data.modules.filter((module) => !module.hideInEditor);
    },
  },
  methods: {
    shouldShowSectionDisableSwitch(module) {
      const isGeneratingResolved = typeof this.$store.state.activeTemplate.isGenerating === 'undefined' || this.$store.state.activeTemplate.isGenerating === 'done';
      return (module.mappedToSection && module.canSkip && isGeneratingResolved) || module.canSkip;
    },
    activateSection(sectionId) {
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.activeSectionId',
        value: sectionId,
      });
      this.scrollToSection(sectionId);
    },
  },
};
</script>
